import { useMemo } from 'react';

import type { SuggestedAnswerFragment } from '../suggested-answers/suggested-answers.graphql.generated';
import { SUGGESTED_ANSWER_VARY } from 'global/constants';
import { isRichtextValueEmpty } from '../shared/logic/get-richtext-value';
import { getRichtextAnswer } from '../shared/logic/get-richtext-answer';

type Props = {
  suggestedAnswerProperties: SuggestedAnswerFragment | null;
};

const useResponseHasSuggestedAnswer = ({
  suggestedAnswerProperties,
}: Props) => {
  const hasRichTextData = useMemo(
    () =>
      suggestedAnswerProperties?.suggestedAnswerType ===
        SUGGESTED_ANSWER_VARY ||
      suggestedAnswerProperties?.suggestedAnswers?.some(
        suggestedData => !isRichtextValueEmpty(getRichtextAnswer(suggestedData))
      ),
    [suggestedAnswerProperties]
  );

  return hasRichTextData;
};

export default useResponseHasSuggestedAnswer;
